import React from 'react'
import { FormLabel, Stack, TextField } from '@mui/material'
import { TextFieldProps } from '@mui/material/TextField/TextField'
import { Controller, ControllerRenderProps, useFormContext } from 'react-hook-form'
import InputMask from 'react-input-mask'

export interface Option {
  label: string | number
  value: string | number | boolean
}

type IFormInputProps = {
  name: string
  label: string
} & TextFieldProps

/** FormPhone mask is 10-digit US national format; strip +1 / leading 1 from E.164 values. */
function toNationalUsDigits(phone?: string | null): string {
  const digits = (phone || '').replace(/\D/g, '')
  if (digits.length === 11 && digits.startsWith('1')) {
    return digits.slice(1)
  }
  if (digits.length > 10) {
    return digits.slice(-10)
  }
  return digits
}

const FormPhone = (props: IFormInputProps) => {
  const { name, label, onChange, required, disabled } = props

  const {
    control,
    formState: { errors },
  } = useFormContext()

  const handleChange =
    (field: ControllerRenderProps) => (e: React.ChangeEvent<HTMLInputElement>) => {
      field.onChange(toNationalUsDigits(e.target.value))
    }

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Stack spacing={0.5}>
          {label && <FormLabel required={required}>{label}</FormLabel>}
          <InputMask
            mask="(999) 999-9999"
            value={toNationalUsDigits(field.value)}
            onChange={handleChange(field)}
            disabled={disabled}
          >
            {(inputProps) => (
              <TextField
                required={required}
                size="small"
                disabled={disabled}
                {...inputProps}
                error={!!errors[name]}
                helperText={(errors[name] ? errors[name]?.message : '') as string}
              />
            )}
          </InputMask>
        </Stack>
      )}
    />
  )
}

export default React.memo(FormPhone)
